import { useEffect, useState } from "react";

import TextInput from "./TextInput";

export default function NumberInput(props) {
    const { onChange, value, ...restProps } = props;

    const [raw, setRaw] = useState(value?.toString?.() ?? "");

    useEffect(
        () => {
            const v = parseFloat(raw.replaceAll(",", "."));
            if (Number.isNaN(v)) return;
            if (v === value) return;
            onChange(v);
        },
        [raw],
    );

    useEffect(
        () => {
            const v = parseFloat(raw);
            if (v !== value) setRaw(value?.toString?.() ?? "");
        },
        [value],
    );

    return (
        <TextInput
            inputMode="decimal"
            placeholder="value"
            onChange={ setRaw }
            type="number"
            value={ raw }
            { ...restProps }
        />
    );
}
